import React from "react";
import { Box, Stack, TextField, IconButton, Button, Autocomplete } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

const EditableList = ({
  items = [],
  onChange,
  descricaoLabel = "Descrição",
  valorLabel = "Valor",
  descricaoMode = "text", // 'text' | 'autocomplete'
  descricaoOptions = [],
  descricaoFreeSolo = true,
}) => {
  const handleItemChange = (index, key, value) => {
    const next = items.map((it, i) => (i === index ? { ...it, [key]: value } : it));
    onChange(next);
  };

  const addItem = () => onChange([...(items || []), { descricao: "", valor: "" }]);
  const removeItem = (index) => onChange(items.filter((_, i) => i !== index));

  return (
    <Box>
      <Stack spacing={1}>
        {(items || []).map((it, idx) => (
          <Stack key={idx} direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "center" }}>
            {descricaoMode === "autocomplete" ? (
              <Autocomplete
                size="small"
                options={descricaoOptions}
                freeSolo={descricaoFreeSolo}
                value={it.descricao || ""}
                onInputChange={(_, newValue) => handleItemChange(idx, "descricao", newValue)}
                renderInput={(params) => (
                  <TextField {...params} label={descricaoLabel} fullWidth />
                )}
                sx={{ flex: 1, minWidth: 260 }}
              />
            ) : (
              <TextField
                size="small"
                label={descricaoLabel}
                fullWidth
                value={it.descricao || ""}
                onChange={(e) => handleItemChange(idx, "descricao", e.target.value)}
              />
            )}

            <TextField
              size="small"
              label={valorLabel}
              type="number"
              value={it.valor || ""}
              onChange={(e) => handleItemChange(idx, "valor", e.target.value)}
              sx={{ width: { xs: "100%", sm: 160 } }}
              slotProps={{ step: "0.01" }}
            />
            <IconButton color="error" onClick={() => removeItem(idx)} aria-label="remover" sx={{ alignSelf: { xs: "flex-end", sm: "center" } }}>
              <DeleteIcon />
            </IconButton>
          </Stack>
        ))}
        <Button startIcon={<AddIcon />} variant="outlined" onClick={addItem} sx={{ alignSelf: "flex-start" }}>
          Adicionar
        </Button>
      </Stack>
    </Box>
  );
};

export default EditableList;